<script lang="typescript">
    import ProductCode from "./ProductCode.svelte";
    import { lensOption } from "./appData";
    import type { LensVariant, LensCode, LensSubCategory } from "./types";

    export let variant: LensVariant;
    export let codes: LensCode | LensSubCategory[];

    let topImage: HTMLImageElement;

    const handleMouseEnter = () => {
        topImage.classList.add("opacity-0");
    };
    const handleMouseLeave = () => {
        topImage.classList.remove("opacity-0");
    };
</script>

<li on:mouseenter={handleMouseEnter} on:mouseleave={handleMouseLeave} class="local-container">
    <div
        class="img-container w-20 h-20 img-background relative mb-4 lg:mb-auto"
        style={`background-image: url(${variant.image.after})`}
    >
        <img
            bind:this={topImage}
            src={variant.image.before}
            class="hide-on-hover w-20 h-20 object-cover rounded-full absolute top-0 left-0"
            alt="spectacle lens"
        />
    </div>
    <div class="flex flex-col justify-between w-full h-full lg:pl-8 items-stretch">
        <div class="w-full flex justify-between flex-col md:flex-row">
            <h1 class="font-medium inline">{variant.name}</h1>
        </div>
        <div class="mt-4 flex flex-row items-start justify-between h-full">
            <div class="w-full h-full">
                <ProductCode code={codes} classes="space-y-2" />
                {#if variant.optionType === lensOption.ANTIFOG}
                    <p class="mt-4">
                        *Price includes Anti-Fog lens solution (add code 10502986 to order)
                    </p>
                {/if}
            </div>
        </div>
    </div>
</li>

<style>
    .local-container {
        @apply items-start hover:shadow-md transition-shadow w-full;
        @apply bg-background flex p-6 lg:p-8;
        @apply flex-col lg:flex-row;
    }

    .img-container {
        min-width: 5rem;
        min-height: 5rem;
    }
</style>
